// © Microsoft Corporation. All rights reserved.
import { WebWorkerMessageId } from "./Constants";
import { addPerfMarker } from "@msnews/web-worker-shared-utils";
import { environment } from "./Environment";
import { registerDataMessageHandler } from "./MessageHandler";
import { sendMessage } from "./PostMessage";
// Register perfMarker message handler
registerDataMessageHandler(WebWorkerMessageId.PerfMarkers, sendPerfMarkers);
/** All markers. */
export const perfMarkers = {};
/** The performance marker name prefix. */
const markerPrefix = "WW.";
/**
 * Calls the addPerfMarker function from shared-utils with WW markerPrefix prefix.
 * If the start marker is already called and this call is for end marker, it'll get latency and record it.
 * @param name - The marker name
 */
export function addWWPerfMarker(name) {
    const perfMarker = addPerfMarker(`${markerPrefix}${name}`);
    if (perfMarker) {
        perfMarkers[perfMarker.name] = perfMarker.timeTaken;
    }
}
/**
 * Records the time stamp of the given marker.
 * @param markerName - The marker name
 * @param customTime - A previously recorded / custom timing value to use instead of performance.now()
 */
export function perfMarker(markerName = "", customTime) {
    const mark = `${markerPrefix}${markerName}`;
    if (!perfMarkers[mark]) {
        perfMarkers[mark] = Math.round((customTime || performance.now()) + environment.perfTimeOffset);
    }
}
/**
 * Removes recorded time stamp for the given marker.
 * @param markerName - The marker name
 */
export function removePerfMarker(markerName = "") {
    const mark = `${markerPrefix}${markerName}`;
    if (perfMarkers[mark]) {
        delete perfMarkers[mark];
    }
}
/** Sends web worker perf markers to main thread */
function sendPerfMarkers() {
    sendMessage({ id: WebWorkerMessageId.PerfMarkers, fetched: true, payload: perfMarkers });
}
//# sourceMappingURL=PerfMarker.js.map